import { render, staticRenderFns } from "./TheCreditsTabs.vue?vue&type=template&id=0462e14a&scoped=true"
import script from "./TheCreditsTabs.vue?vue&type=script&lang=js"
export * from "./TheCreditsTabs.vue?vue&type=script&lang=js"
import style0 from "./TheCreditsTabs.vue?vue&type=style&index=0&id=0462e14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462e14a",
  null
  
)

export default component.exports